<template>
  <!-- <v-chart
    :style="{width: '100%', height: `${heightChart}px`}"
    class="chart"
    id="chart"
    :option="option"
    autoresize
    manual-update
  /> -->
    <div :id="chartId" :style="{width: '100%', height: `${heightChart}px`}"></div>
</template>

<script>
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { PieChart, BarChart } from 'echarts/charts';
import { GridComponent } from 'echarts/components';
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
} from 'echarts/components'
import VChart from 'vue-echarts'
import * as echarts from 'echarts'

use([
  CanvasRenderer,
  PieChart,
  BarChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent
])

export default {
  props: {
    optionChart: {
      type: Object,
      default: () => ({}),
    },
    heightChart: {
      type: String,
      default: '370'
    },
    chartId: {
      type: String,
      default: 'chart'
    },
    newData: {
      type: Boolean,
      default: false
    }
  },
  components: {
    VChart,
  },
  data() {
    return {
      option: {},
      myChart: undefined,
    }
  },
  methods: {
    initChart() {
      this.myChart = echarts.init(document.getElementById(this.chartId))
      this.option && this.myChart.setOption(this.option)
      this.myChart.on('click', (params) => {
        this.$emit('chartClick', params)
      })
      window.onresize = () => {
        
      }
      window.addEventListener('resize',() => {
        this.myChart.resize()
      })
    }
  },
  created() {
    this.option = this.optionChart
    setTimeout(() => {
      this.initChart()
    }, 500)
  },
  watch: {
    newData(val) {
      this.option = this.optionChart
      // console.log('this.option', this.option)
      setTimeout(() => {
        this.initChart()
      }, 1000)
    }
  }
}
</script>

<style scoped>
</style>
